module.exports = __webpack_public_path__ + "static/media/rectangle-17.7c121424.svg";